import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1).max(128),
    remember: z.boolean().default(false),
});
export const mfaVerifySchema = z
    .object({
    code: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
    recoveryCode: z.string().min(8).max(64).optional(),
})
    .refine((v) => Boolean(v.code) !== Boolean(v.recoveryCode), {
    message: 'Provide exactly one of code or recoveryCode',
});
/** The second step of login when the account has a confirmed MFA factor
 * (docs/architecture/05 § MFA) — `challengeToken` ties this call back to the
 * `login()` call that returned `mfaRequired`. */
export const mfaChallengeSchema = z
    .object({
    challengeToken: z.string().min(16),
    code: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
    recoveryCode: z.string().min(8).max(64).optional(),
})
    .refine((v) => Boolean(v.code) !== Boolean(v.recoveryCode), {
    message: 'Provide exactly one of code or recoveryCode',
});
export const mfaChallengeResponseSchema = z.object({
    mfaRequired: z.literal(true),
    challengeToken: z.string(),
});
export const mfaEnrollStartResponseSchema = z.object({
    secret: z.string(),
    otpauthUrl: z.string(),
});
export const mfaEnrollConfirmSchema = z.object({ code: z.string().regex(/^\d{6}$/) });
export const mfaEnrollConfirmResponseSchema = z.object({ recoveryCodes: z.array(z.string()) });
export const mfaStatusResponseSchema = z.object({ enabled: z.boolean() });
export const mfaDisableSchema = mfaVerifySchema;
export const forgotPasswordSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
});
/** NIST 800-63B: length matters, not composition rules
 * (docs/architecture/05-authentication.md § 3). */
export const resetPasswordSchema = z.object({
    token: z.string().min(16),
    newPassword: z.string().min(12).max(128),
});
export const sessionUserSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string(),
    avatarUrl: z.string().url().nullable(),
});
export const sessionResponseSchema = z.object({
    user: sessionUserSchema,
    /** The caller's own membership id — e.g. so the frontend can tell which
     * of a shared `SavedView`'s rows it owns (only the owner can edit/delete
     * one) without a second round-trip to figure that out. */
    membershipId: z.string().uuid(),
    tenant: z.object({ id: z.string().uuid(), name: z.string(), slug: z.string() }),
    permissions: z.array(z.string()),
    csrfToken: z.string(),
});
export const loginResponseSchema = z.union([sessionResponseSchema, mfaChallengeResponseSchema]);
//# sourceMappingURL=schemas.js.map